import { useQuery } from "@tanstack/react-query";
import { matchPath, useLocation } from "react-router-dom";
import { supportQueryKeys } from "../features/support";
import { SUCCESS_STATUS } from "../constants";
import type { ApiEnvelope, SupportQuestionsData } from "../features/support/types";

/**
 * Pattern for each migrated slice:
 *  1. Add a `matchPath` call for the detail route that needs a dynamic label.
 *  2. Add a `useQuery({ enabled: false })` for the matching query key.
 *     `enabled: false` prevents this hook from fetching; the feature page owns
 *     the fetch. This hook only subscribes as a cache observer so that `Header`
 *     re-renders automatically when the feature's query resolves.
 *  3. Spread the data into the returned object when the route matches.
 */
export function useQueryBreadcrumbs(): Record<string, unknown> {
  const { pathname } = useLocation();

  const supportMatch = matchPath({ path: "/admin/support/:supportDataId", end: false }, pathname);

  const { data: supportData } = useQuery({
    queryKey: supportQueryKeys.questions(supportMatch?.params?.supportDataId),
    enabled: false,
    select: (envelope: ApiEnvelope<SupportQuestionsData>): SupportQuestionsData => (envelope?.status === SUCCESS_STATUS ? envelope.data ?? {} : {}),
  });

  // ── future migrations: add one block per slice ─────────────────────────────
  // Template:
  //
  // const formularyMatch = matchPath(
  //   { path: '/admin/formulary/:formularyId', end: false },
  //   pathname,
  // );
  // const { data: formularyData } = useQuery({
  //   queryKey: formularyQueryKeys.detail(formularyMatch?.params?.formularyId),
  //   enabled: false,
  // });

  return {
    ...(supportMatch != null && supportData != null ? { support: supportData } : {}),
    // ...(formularyMatch != null && formularyData != null ? { formulary: formularyData } : {}),
  };
}
